import { Base } from 'src/api/Base'

export class CategoryAPI extends Base {
  static get entity() {
    return 'category'
  }

  static async getList({ withProducts = false }) {
    const params = {
      ...this.datepicker,
      withProducts,
    }

    const { data } = await this.request().get(`/${this.entity}/list`, {
      params,
    })

    return data
  }

  static async create({ name, color }) {
    const { dealerGroupId } = this.datepicker

    const params = {
      dealerGroupId,
    }

    const body = {
      name,
      color,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/create`, body, { params })

    return data
  }

  static async update({ name, color, id, productCategoryId }) {
    const params = {
      ...this.datepicker,
      productCategoryId,
    }

    const body = {
      name,
      color,
      id,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/update`, body, { params })

    return data
  }

  static async move({ ordinal, productCategoryId }) {
    const params = {
      ...this.datepicker,
      productCategoryId,
    }

    const body = {
      ordinal: ordinal + 1,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/move`, body, { params })

    return data
  }
}
